import { useTranslation } from 'react-i18next';

import { Tooltip } from 'components/Tooltip';

import { useBulkReveal } from '../../useBulkReveal';

import { StyledBulkRevealButton } from './styles';

interface BulkRevealButtonProps {
  isDisabled?: boolean;
  onRevealFinish: VoidFunction;
}

export const BulkRevealButton = ({ isDisabled, onRevealFinish }: BulkRevealButtonProps) => {
  const { t } = useTranslation();

  const { areAllContactsRevealed, isPending, onBulkReveal } = useBulkReveal({
    onRevealFinish,
  });

  if (areAllContactsRevealed) {
    return (
      <Tooltip content={t('contact_card.revealed_all')} placement="top" minWidth={230}>
        <StyledBulkRevealButton variant="flat" data-automation="ContactReveal" disabled>
          {t('contact_card.reveal')}
        </StyledBulkRevealButton>
      </Tooltip>
    );
  }

  return (
    <StyledBulkRevealButton
      variant="flat"
      data-automation="ContactReveal"
      disabled={isDisabled || isPending}
      onClick={onBulkReveal}
    >
      {t('contact_card.reveal')}
    </StyledBulkRevealButton>
  );
};
